<template>
  <Button class="mybutton">
    
  <div class="cookies-banner">
    <a href="#" class="close-button" @click.prevent="acceptCookies">
      <img src="~@/assets/icons/icon-popup-close-white.svg" />
    </a>
    <div class="container">
      <div v-html="message"></div>
    </div>
  </div>
  </Button>
</template>

<script>
import { marked } from "marked";

export default {
  name: "VCookiesBanner",
  computed: {
    message() {
      return marked(this.$t("cookies.info"));
    }
  },
  methods: {
    acceptCookies() {
      this.$cookies.set("cookiesAccepted", true);
      this.$emit("accepted");
    }
  }
};
</script>

<style lang="scss">
@import "../styles/variables";

.cookies-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: $color-accent;
  color: $color-white;
  padding: 30px 0;

  a {
    color: $color-white;
    font-weight: bold;
    text-decoration: underline;
  }
}

.close-button {
  position: absolute;
  top: 20px;
  right: 20px;
}
</style>
